import { Link } from 'react-router-dom';
import { FaUserCircle } from 'react-icons/fa';
import { formatDate } from '@/utils/formatDate';
import { containerVariants, dateVariants, iconVariants } from '@/components/ArticleAuthor.styles';
import type { VariantProps } from 'class-variance-authority';

interface ArticleAuthorProps extends VariantProps<typeof iconVariants> {
  id: number;
  name: string;
  publishedAt: string | undefined;
  image?: string;
}

const ArticleAuthor = ({ id, image, name, publishedAt, size = 'small' }: ArticleAuthorProps) => {
  const iconStyleClasses = iconVariants({ size });
  const dateStyleClasses = dateVariants({ size });
  const containerStyleClasses = containerVariants({ size });

  return (
    <address data-cy='article-author' className={containerStyleClasses}>
      {image ? (
        <img src={image} alt={name} className={iconStyleClasses} />
      ) : (
        <FaUserCircle className={iconStyleClasses} />
      )}

      <Link to={`/author/${id}`} className='font-bold leading-[1.1rem] hover:underline hover:text-teal-600'>
        {name}
      </Link>

      <time className={dateStyleClasses}>{formatDate(publishedAt ?? '')}</time>
    </address>
  );
};

export default ArticleAuthor;
